export enum NetworkTagTextColor {
  N3 = '#000000',
  TN3 = '#000000',
  LEGACY = '#000000',
  X = '#FFFFFF',
}
